//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["openStatus", "orderId"],
  data() {
    return {
      dynamicValidateForm: {
        remarks: "",
        orderId: "",
      },
      stepLoading: false,
      dialogVisible_order: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_order = this.openStatus;
    },
    orderId(val1, val2) {
      this.dynamicValidateForm.orderId = val1;
    },
  },
  mounted() {
    this.dynamicValidateForm.orderId = this.orderId;
  },
  methods: {
    getOrders() {
      this.dynamicValidateForm.remarks = '';
      this.stepLoading = true;
      this.$http.szOrder.getDelOrder(this.dynamicValidateForm).then((res) => {
        this.stepLoading = false;
        if (res.status == 1) {
          this.$emit("successMark", true);
          this.dialogVisible_order = false;
          this.$emit("closeStatus", true);
          this.$message({
            message: "取消成功",
            type: "success",
          });
        }
      });
    },
    handleClose() {
      this.dialogVisible_order = false;
      this.$emit("closeStatus", true);
    },
  },
};
